import { Route, Routes } from 'react-router-dom'
import { ActivityPage } from './activityPage'
import { FlightPage } from './flightPage'
import { TodoPage } from './todoPage'

export const ItemRouter = () => {
    return (
        <Routes>
            <Route path="/flight/:_id" element={<FlightPage />} />
            <Route path="/todo/:_id" element={<TodoPage />} />
            <Route path="/activity/:_id" element={<ActivityPage />} />
        </Routes>
    )
}
